// ----------------------------------------------------------------------------
// Component: Featured Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';

// Styles
import './_product-highlight.scss';